import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://d91fdae241dd1d0311b9a176e7400fdb@o4508919304224768.ingest.us.sentry.io/4508957585702912",
  integrations: [],
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: '0.1.0' // Update to the new release version
});

//# debugId=dfb8cca9-af15-5423-a3a1-10bc0eb6c820

